// M3: tracks the customer an agent/admin is currently ordering on behalf of.
export const agentOrderActionTypes = {
  SET_SELECTED_CUSTOMER: "SET_SELECTED_CUSTOMER",
  CLEAR_SELECTED_CUSTOMER: "CLEAR_SELECTED_CUSTOMER",
};
